import React, { useContext, useEffect, useState } from "react";
import { Text, View, Image, StyleSheet, TouchableOpacity, DeviceEventEmitter, Platform, useWindowDimensions } from "react-native";

import { CategoriesContext } from "../context/CategoriesContext";
import { ProductsContext } from "../context/ProductsContext";
import { GlobalContext } from "../context/GlobalContext";
import { PaymentMethodsContext } from "../context/PaymentMethodsContext";

import * as Linking from 'expo-linking';

// import SatService from "../services/SatService";

import Config from "../config/Config";
import WooService from "../services/WooService";
import PrintOrderService from "../services/PrintOrderService";

const config = new Config();

const MILISECS_1000 = 1000;

const HomeScreen = ({ navigation }) => {
  const { width, height } = useWindowDimensions();
  const { loadCategories } = useContext(CategoriesContext);
  const { loadProducts } = useContext(ProductsContext);
  const { setId, printers, loadPrinters, initElginPayService } = useContext(GlobalContext);
  const { loadPaymentMethods } = useContext(PaymentMethodsContext);

  const [printTimer, setPrintTimer] = useState();
  const [isPrinting, setIsPrinting] = useState(false);

  const wooService = new WooService();

  const printCheck = async (printersList) => {
    if (!isPrinting) {
      setIsPrinting(true);
      const { data } = await wooService.getOrdersToPrint();
      const startTime = Date.now();
console.log("Data: ", data);
console.log("printers: ", printersList);

      for (var index = 0; index < data.length; index++) {
        if (!['.', '..', 'index.json', 'printers-settings.json'].includes(data[index])) {
          // Break execution to avoid overlapping printing
          console.log("Starttime: ", startTime);
          console.log("Now: ", Date.now());
          if (Date.now() - startTime > config.PRINTER_POLL_INTERVAL - MILISECS_1000) {
console.log("Printing taking long to settle");
            break;
          } else {
            const orderFile = await wooService.getFileToPrint(data[index]);
console.log("Order file: ", orderFile);
console.log("Order file data: ", orderFile.data);
console.log("Order file data order", orderFile.data.order);
console.log("Printing file: ", data[index]);
            const printOrderService = new PrintOrderService();
            const printResult = await printOrderService.printOrderInfo(printersList, orderFile.data.order);
console.log("Deleting file: ", data[index]);
            // if (printResult === "OK") { 
              wooService.deletePrintedFile(data[index]);
console.log("Deleted file: ", data[index]);
            // }
          }
        }
      }
      setIsPrinting(false);
    }
  }

  const isPdvPrinterEnabled = async () => {
    // Get PDV Print Server Configuration from Serveer
    const { pdvPrinterConfig } = await wooService.getPdvPrinterConfig();

    // return pdvPrinterConfig;
    return true;
  }

  const initPrinters = async () => {
    if (!printers.find(printer => printer.name === 'service')) {
      if (printTimer) {
        clearInterval(printTimer);
      } 
      const printersList = await loadPrinters();
      setPrintTimer(setInterval(printCheck, config.PRINTER_POLL_INTERVAL, printersList));
    }
  }

  useEffect(() => {
    if (Platform.OS === 'android') {
      if (config.BUILD_PRODUCT === config.CONTROL_CENTER_ELGINPAY) {
        initElginPayService();
      } else if (config.BUILD_PRODUCT === config.CONTROL_CENTER_M10) {
        if (isPdvPrinterEnabled()) {
          initPrinters();
        }
      }
    }
    loadCategories();
    loadProducts();
    loadPaymentMethods();

    let readyEvent = DeviceEventEmitter.addListener('ready', event => {
      readyEvent.remove();
      if (config.BUILD_PRODUCT === config.PEDSEGURO_INDOOR) {
        newOrder();
      }
    });

    // Gets param from QR-code (table_id)
    Linking.parseInitialURLAsync()
    .then(params => {
      if (params.queryParams && params.queryParams.table_id) {
        setId(params.queryParams.table_id);
      }
    });
console.log("Initialization done");

    /*
    const unsubscribe = navigation.addListener('beforeRemove', (e) => {
      console.log("back pressed at home");

      for (const printer of printers) {
        printer.destroyPrinter();
      }
      navigation.dispatch(e.data.action)
    });
    console.log(unsubscribe);
    return unsubscribe;
    */
  }, []);

  const newOrder = async () => {
    navigation.navigate("Categories", { navigationAction: "NEW_ORDER" });
  }

  const listOrders = () => {
    navigation.navigate("Orders", { order: null, response: null });
  }

  const showCashBalance = () => {
    wooService.getOpenBalance()
    .then(response => {
      if (response.data && response.data.length > 0) {
        const openTime = new Date(response.data[0].opentime);
        setBalanceOpenTime(openTime)
        setAction("close");
        setModalMessage(`O caixa foi aberto às ${openTime.toLocaleTimeString()} de ${openTime.toLocaleDateString()}.\nQual operação deseja realizar?`);
      } else {
        setAction("open");
        setModalMessage("O caixa ainda não foi aberto.\nDeseja abrir agora?");
      }
      setModalVisible(true);
    })
    .catch(error => {
      setAction("error");
      setModalMessage("Erro na comunicação com o servidor.\nDeseja tentar novamente?");
      setModalVisible(true);
    });
  }

  const openCloseBalance = (action) => {
    setModalVisible(false);
    if (action === "open" || action === "close") {
        navigation.navigate("CashBalance", {action: action});
    } else if (action === "error") {
      showCashBalance();
    }
  }

  const balanceEntries = (type) => {
    setModalVisible(false);
    navigation.navigate("BalanceEntries", {action: type});
  }

  const getBalanceData = () => {
    const response =  wooService.getBalanceData(8);
    console.log("Response: ", response);
  }

  const checkSat = async () => {
    // const satService = new SatService();
    // satService.statusOperacional("123456789");
    // satService.consultarSAT();

    // let actualEvent = DeviceEventEmitter.addListener('eventStatusSat', event => {
        // var statusSatReturn = event.statusSat;
    //     console.log("statusSatReturn.: ", event);
    //     actualEvent.remove();
    // });
  }

  return (
    <View>
      <Image style={[styles.logo, styles.customerLogo]} source={config.HOME_LOGO} />
      {!config.TEST_VERSION &&
      <View>
        {config.BUILD_PRODUCT === config.PEDSEGURO_INDOOR &&
          <View style={styles.waitBox}>
            <Text style={styles.waitText}>Carregando produtos. Aguarde...</Text>
          </View>
        }
        {config.BUILD_PRODUCT !== config.PEDSEGURO_INDOOR &&
          <View>
            <TouchableOpacity style={styles.buttons} onPress={newOrder}>
              <Text style={styles.buttonText}>Fazer Pedido</Text>
            </TouchableOpacity>
            <TouchableOpacity style={styles.buttons} onPress={listOrders}>
              <Text style={styles.buttonText}>Ver Pedidos</Text>
            </TouchableOpacity>
            {(Platform.OS !== 'android') &&
              <TouchableOpacity style={styles.buttons} onPress={() => navigation.navigate("Balance")}>
                <Text style={styles.buttonText}>Gerenciar Caixa</Text>
              </TouchableOpacity>
            }
          </View>
        }
        <View style={width < config.WIDTH_TRESHOLD ? styles.verticalLayout : styles.horizontalLayout}>
          <View style={{flexDirection: "column", alignSelf: 'center'}}>
            <Text style={{marginTop: 30, alignSelf: 'center'}}>Criado por</Text>
            <Image style={styles.pedSeguroLogo} source={require("../../assets/pedseguro.png")} />
          </View>
          <View style={{width: 50, height: 0}}></View>
          <View style={{flexDirection: "column", alignSelf: 'center'}}>
            <Text style={{marginTop: 20, alignSelf: 'center'}}>em parceria com</Text>
            <Image style={styles.elginLogo} source={require("../../assets/elgin-logo.png")} />
          </View>
        </View>
      </View>
      }
      {config.TEST_VERSION &&
        <TouchableOpacity style={styles.buttons} onPress={checkSat}>
          <Text style={styles.buttonText}>Status do SAT</Text>
        </TouchableOpacity>
      }
    </View>);
};

const styles = StyleSheet.create({
  verticalLayout: {
    flexDirection: 'column',
    alignSelf: 'center'
  },
  horizontalLayout: {
    flexDirection: 'row',
    alignSelf: 'center',
  },
  customerLogo: {
    marginTop: 20,
    marginBottom: 20,
    alignSelf: 'center'
  },
  logo: {
    width: 160,
    height: 80,
    resizeMode: 'contain'
  },
  pedSeguroLogo: {
    width: 100,
    height: 50,
    resizeMode: 'contain',
  },
  elginLogo: {
    marginTop: 12,
    width: 200,
    height: 39,
    resizeMode: 'contain',
  },
  buttons: {
    backgroundColor: '#F0A22E',
    width: 400,
    marginVertical: 10,
    padding: 15,
    borderRadius: 10,
    alignSelf: 'center'
  },
  buttonText: {
    fontSize: 20,
    fontWeight: 'bold',
    alignSelf: 'center'
  },
  waitBox: {
    justifyContent: 'center',
    alignSelf: 'center',
    width: 300,
    height: 120,
    backgroundColor: 'white',
    padding: 20,
    marginTop: 80,
    borderRadius: 10
  },
  waitText: {
    fontSize: 17,
    fontWeight: 'bold',
    textAlign: 'center'
  },
});

export default HomeScreen;